export const BASE_PATH = '/api/v1/bulas'